import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
`;

const StatCard = styled.div`
  background: #f8fafc;
  padding: 20px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  text-align: center;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: #667eea;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
`;

const StatIcon = styled.div`
  font-size: 1.5rem;
  margin-bottom: 12px;
  color: #667eea;
`;

const StatValue = styled.div`
  font-size: 1.75rem;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 4px;
`;

const StatLabel = styled.div`
  color: #718096;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 500;
`;

const StatusIndicator = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
  background-color: ${props => {
    if (props.status === 'online') return '#48bb78';
    if (props.status === 'offline') return '#f56565';
    return '#ed8936';
  }};
`;

const LoadingSpinner = styled.div`
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #e2e8f0;
  border-top: 2px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const StatsPanel = () => {
  const [stats, setStats] = useState({
    serverStatus: 'offline',
    activeStreams: '-',
    viewerCount: '-',
    uptime: '00:00:00'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
    const interval = setInterval(fetchStats, 30000);
    const uptimeInterval = setInterval(updateUptime, 1000);

    return () => {
      clearInterval(interval);
      clearInterval(uptimeInterval);
    };
  }, []);

  const fetchStats = async () => {
    try {
      setLoading(true);
      const response = await fetch('http://159.198.65.99:3000/api/status', {
        headers: {
          'Authorization': 'Bearer holytv_api_key_2024_secure_streaming_server'
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setStats(prev => ({
          ...prev,
          serverStatus: 'online',
          activeStreams: data.activeStreams || 0,
          viewerCount: data.totalViewers || 0
        }));
      } else {
        setStats(prev => ({
          ...prev,
          serverStatus: 'offline'
        }));
      }
    } catch (error) {
      console.error('Error fetching stats:', error);
      setStats(prev => ({
        ...prev,
        serverStatus: 'offline'
      }));
    } finally {
      setLoading(false);
    }
  };

  const updateUptime = () => {
    setStats(prev => {
      const [hours, minutes, seconds] = prev.uptime.split(':').map(Number);
      const totalSeconds = hours * 3600 + minutes * 60 + seconds + 1;
      const newHours = Math.floor(totalSeconds / 3600);
      const newMinutes = Math.floor((totalSeconds % 3600) / 60);
      const newSeconds = totalSeconds % 60;
      
      return {
        ...prev,
        uptime: `${newHours.toString().padStart(2, '0')}:${newMinutes.toString().padStart(2, '0')}:${newSeconds.toString().padStart(2, '0')}`
      };
    });
  };

  return (
    <StatsGrid>
      <StatCard>
        <StatIcon>
          <i className="fas fa-server"></i>
        </StatIcon>
        <StatValue>
          {loading ? <LoadingSpinner /> : (
            <>
              <StatusIndicator status={stats.serverStatus} />
              {stats.serverStatus === 'online' ? 'Online' : 'Offline'}
            </>
          )}
        </StatValue>
        <StatLabel>Server Status</StatLabel>
      </StatCard>
      
      <StatCard>
        <StatIcon>
          <i className="fas fa-broadcast-tower"></i>
        </StatIcon>
        <StatValue>
          {loading ? <LoadingSpinner /> : stats.activeStreams}
        </StatValue>
        <StatLabel>Active Streams</StatLabel>
      </StatCard>
      
      <StatCard>
        <StatIcon>
          <i className="fas fa-users"></i>
        </StatIcon>
        <StatValue>
          {loading ? <LoadingSpinner /> : stats.viewerCount}
        </StatValue>
        <StatLabel>Live Viewers</StatLabel>
      </StatCard>
      
      <StatCard>
        <StatIcon>
          <i className="fas fa-clock"></i>
        </StatIcon>
        <StatValue>{stats.uptime}</StatValue>
        <StatLabel>Uptime</StatLabel>
      </StatCard>
    </StatsGrid>
  );
};

export default StatsPanel; 